<template>
    <base-modal :value="value" @input="canceled"
        modal-classes="modal-danger"
        modal-content-classes="bg-gradient-danger"
    >
        <div class="py-3 text-center">
            <i class="tim-icons icon-t-warning icon-3x mb-4"></i>
            <slot></slot>
        </div>

        <template slot="footer">
            <div class="text-center">
                <base-button type="white" @click="close">{{ $t('common.close') }}</base-button>
            </div>
        </template>
    </base-modal>
</template>

<script>
    export default {
        
        props: {
            value: {
                type: Object,
                required: true
            },
        },

        methods: {

            close() {
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                })
            }
        }
    }
</script>